export enum DialogResult {
	SUCCESS,
	ERROR,
	CLOSE
}

export enum DialogModes { 
    CREATE,
    EDIT
}
